import {FC, useState} from 'react'
import {Dropdown} from 'react-bootstrap'

type Props = {
  handleSelectStatus: any
}

const DropdownStatusContent: FC<Props> = ({handleSelectStatus}) => {
  const [selectedName, setSelectedName] = useState<string[]>([])

  const [show, setShow] = useState(false)

  const [selectedStatus, setSelectedStatus] = useState<{
    [key: string]: boolean
  }>({
    belum_dinilai: false,
    lolos: false,
    tidak_lolos: false,
  })

  const [showInput, setShowInput] = useState<string>('')

  const handleCheckboxChange = (e: any, displayName: string) => {
    const checked = e.target.checked
    const statusKey = e.target.name

    // update status
    setSelectedStatus({
      ...selectedStatus,
      [statusKey]: checked,
    })

    // update display name (for input field)
    setSelectedName((prev) => {
      if (checked) {
        return [...prev, displayName]
      } else {
        return prev.filter((item) => item !== displayName)
      }
    })
  }

  const handleApply = () => {
    const selected = Object.entries(selectedStatus)
      .filter(([_, val]) => val)
      .map(([key]) => key)

    setShowInput(selectedName.join(', '))
    handleSelectStatus('status_administrasi', selected)
    setShow(false)
  }

  const handleToggle = (isOpen: boolean) => {
    setShow(isOpen)
  }

  return (
    <Dropdown show={show} onToggle={handleToggle} autoClose='outside'>
      <Dropdown.Toggle
        variant='light'
        className='w-100 text-start fw-bold bg-white p-3 d-flex justify-content-between align-items-center'
        style={{
          border: '1px solid #e4e6ef',
          backgroundImage: 'none',
        }}
      >
        <p>{showInput ? showInput : '--Pilih Status--'}</p>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <div className='mb-2 p-3 row'>
          <div className='col-md-12'>
            <div className='d-flex align-items-center mb-2' style={{minWidth: 0}}>
              <input
                type='checkbox'
                name='belum_dinilai'
                checked={selectedStatus['belum_dinilai']}
                onChange={(e) => handleCheckboxChange(e, 'Belum Penilaian')}
              />
              <label className='px-2'>Belum Penilaian</label>
            </div>
          </div>

          <div className='col-md-12'>
            <div className='d-flex align-items-center mb-2' style={{minWidth: 0}}>
              <input
                type='checkbox'
                name='lolos'
                checked={selectedStatus.lolos}
                onChange={(e) => handleCheckboxChange(e, 'Diterima')}
              />
              <label className='px-2'>Diterima</label>
            </div>
          </div>

          <div className='col-md-12'>
            <div className='d-flex align-items-center mb-2' style={{minWidth: 0}}>
              <input
                type='checkbox'
                name='tidak_lolos'
                checked={selectedStatus['tidak_lolos']}
                onChange={(e) => handleCheckboxChange(e, 'Ditolak')}
              />
              <label className='px-2'>Ditolak</label>
            </div>
          </div>
        </div>

        <div
          className='col-md-12 d-grid px-5 pt-5 pb-3 border border-bottom-0 border-left-0 rounded'
          style={{boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1)'}}
        >
          <button
            className='btn btn-primary btn-sm w-100'
            style={{background: 'var(--Primary-L-500, #F95E2F)'}}
            onClick={handleApply}
          >
            Terapkan
          </button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

const DropdownStatus: FC<Props> = ({handleSelectStatus}) => {
  return <DropdownStatusContent handleSelectStatus={handleSelectStatus} />
}

export default DropdownStatus
